import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';
import type { NewsItem } from '@/types';
import SectionHeading from '@/components/base/SectionHeading';

export default function HotNews() {
  const list = [...(newsList as NewsItem[])]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 6);
  const [featured, ...rest] = list;

  return (
    <section className="bg-background-100 px-4 py-12 md:px-8 md:py-14 lg:px-12">
      <SectionHeading
        eyebrow="News"
        title="热门影视资讯精选"
        description="行业动态、明星资讯与剧透解析，第一时间掌握影视圈最新动向。"
        action={
          <Link
            to="/news"
            className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            全部资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Link
          to={`/news/${featured.id}`}
          className="group relative overflow-hidden rounded-lg"
        >
          <div className="h-64 w-full md:h-80 lg:h-full lg:min-h-[360px]">
            <img
              src={featured.cover}
              alt={featured.title}
              title={`${featured.title} 资讯详情`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent"></div>
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
            <span className="inline-block rounded-md bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
              {featured.category}
            </span>
            <h3 className="mt-3 font-heading text-lg font-semibold leading-snug text-background-50 md:text-xl">
              {featured.title}
            </h3>
            <p className="mt-2 line-clamp-2 text-sm text-background-200">
              {featured.summary}
            </p>
            <p className="mt-3 text-xs text-background-300">
              {featured.date} · {featured.views.toLocaleString()} 阅读
            </p>
          </div>
        </Link>

        <div className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {rest.map((item, index) => (
            <Link
              key={item.id}
              to={`/news/${item.id}`}
              className="group flex flex-1 items-start gap-4 p-4 transition-colors hover:bg-background-100 md:p-5"
            >
              <span className="font-heading text-2xl font-bold text-background-300 transition-colors group-hover:text-primary-400">
                {String(index + 2).padStart(2, '0')}
              </span>
              <div className="min-w-0 flex-1">
                <div className="mb-1.5 flex items-center gap-2 text-xs text-foreground-400">
                  <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
                    {item.category}
                  </span>
                  <span>{item.date}</span>
                </div>
                <h4 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                  {item.title}
                </h4>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}